import React from 'react';

import { Image } from '@/components/client';
import { getStaticCdnUrl } from '@/utils';

import MoisIcon from './_assets/mois.svg';

const AGENCY_LOGO_URL = {
  /** 행정안전부 */
  MOIS: getStaticCdnUrl('agency-logo-mois.png'),
  /** 디지털서비스 개방 */
  ODS: getStaticCdnUrl('agency-logo-ods.png'),
} as const;

export const Agencies = () => {
  return (
    <article className="gap-32 flex-center">
      <div className="h-24 w-84 shrink-0">
        <MoisIcon width={84} height={24} />
      </div>
      <div className="relative h-20 w-106 shrink-0">
        <Image
          fill
          src={AGENCY_LOGO_URL.ODS}
          alt="디지털서비스개방"
          className="object-contain"
          sizes="106px"
        />
      </div>
    </article>
  );
};
